























































































import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import AnxHrLine from "../AnxHrLine/AnxHrLine.vue";
import AnxIcon from "../AnxIcon/AnxIcon.vue";
import AnxLink from "../AnxLink/AnxLink.vue";
import AnxLanguageSwitcher from "../AnxLanguageSwitcher/AnxLanguageSwitcher.vue";
import VueI18n from "vue-i18n";

/**
 * The *anx-header* is a simple header that is displayed on the top of the page
 */
@Component({
  components: { AnxHrLine, AnxLanguageSwitcher, AnxIcon, AnxLink }
})
export default class AnxHeader extends Vue {
  /** Require the url module (import can't be used because it does not have @types) */
  Url = require("url-parse");

  /** The i18n instance from the root vue project */
  @Prop({ default: null }) i18n!: VueI18n | null;
  /** The options that will be passed to the anx-language-switcher */
  @Prop({ default: null }) i18nOptions!: Array<{}> | null;
  /** The icon for the header */
  @Prop({ default: "anexia" }) icon!: string;
  /** The icon size for the header */
  @Prop({ default: "45px" }) iconSize!: string;
  /** The menus for the header */
  @Prop({ default: null }) menus!: Array<{
    menu: string;
    link: string;
    external: boolean | null;
    activeRegex: string | null;
  }> | null;
  /**Specify the width of the Header 530px => 500px real width (15px padding for mobile)*/
  @Prop({ default: "530px" }) width!: string;
  /** The url for the click on the icon (set to null to disable) */
  @Prop({ default: "/" }) iconUrl!: string | null;
  /**
   * This property can be passed instead of the iconUrl
   * The router will push to the passed route name
   * Only works in combination with Vue-Router (will be ignored otherwise)
   */
  @Prop({ default: null }) iconUrlRouteName!: string | null;

  /** this event is emitted when the locale is changed via the language switcher */
  @Emit("localeChange")
  localeChange(locale: string) {
    return locale;
  }

  get cssProps() {
    return {
      "--width": this.width
    };
  }

  /** Checks if the specified link should be active in the header (active means clickable) */
  private isLinkActive(menu: {
    menu: string;
    link: string;
    external: boolean;
    activeRegex: RegExp;
  }): boolean {
    const link = menu.link;

    /** Try to get the current window url via window or $route ($route is more appropriate) */
    let currentUrl = null;
    if (typeof window !== "undefined") currentUrl = window.location.href;
    if (this.$route) currentUrl = this.$route.path;

    /** If the current window url could not be retrieved, we can't compare the urls */
    if (!currentUrl) return false;

    const url = new this.Url(link);
    const windowUrl = new this.Url(currentUrl);

    /** URL must not always be an exact match to be highlighted, you can also provide a regex */
    let matches = false;
    matches = url.href === windowUrl.href;
    if (!matches && menu.activeRegex) {
      matches = windowUrl.href.match(menu.activeRegex) !== null ? true : false;
    }

    /** Link is only active, if it doesn't match. Otherwise it is deactivated (not clickable) */
    return !matches;
  }
}
